import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Loader from "./Loader";
import Logo from '../images/school_logo.png';
import '../styles/Login.css';
import Back from '../images/back3.webp';
import SuccessModal from './SuccessModal';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { resetPassword } = useUserAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setFormSubmitting(true);
    try {
      await resetPassword(email);
      setSuccessMessage('Password reset email sent. Check your inbox.');
      setEmail('');
      setShowModal(true);
    } catch (error) {
      setError("An error occurred. Please try again.");
      setShowModal(true);
    }
    setFormSubmitting(false);
  };

  useEffect(() => {
    const img = new Image();
    img.src = Back;
    img.onload = () => {
      setLoading(false);
    };
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {formSubmitting && <Loader text={"SENDING"} />}
      <div className="top-elements row align-center space-between">
        <Link to="/login" className="back-link"><i className="fa-solid fa-arrow-left size3"></i></Link>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />          
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}><i className="fa-solid fa-rotate-right size4"></i></Link>
      </div>
      <div className="login-page-items column align-center" style={{ backgroundImage: `url(${Back})` }}>
        <div className="form-items">
          <p className="login-heading size3 align-center justify-center">FORGOT PASSWORD</p>
          <p className="text-center forgot-password-text">We will send you a link to the email address you provide below. Follow the instructions to change your password.</p>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              id="login-email"
              className="input-field"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="row align-center justify-center">
              <button type="Submit" className="login-button">
                SEND
              </button>
              <Link to="/login" className="forgot-password row align-center justify-center size5">SIGN IN?</Link>
            </div>
          </form>
        </div>
      </div>
      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setError("");
            setSuccessMessage("");
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default ForgotPassword;
